import { colors, measures } from "../ui";

import { EditorView } from "@codemirror/view";
import { lightTheme } from "../theme";

const cmPageLine = {
  "background-color": colors.lightGrey,
  "padding-block-start": "1rem",
  "padding-block-end": "1rem",
  "border-block-start": "1rem solid ",
  "border-block-end": "1rem solid",
  "border-block-start-color": lightTheme.backgroundColor,
  "border-block-end-color": lightTheme.backgroundColor

};

export const QPTheme = EditorView.theme({
  ".cm-activeLine.cm-page-line": cmPageLine,
  ".cm-activeLine.cm-line": { background: "none" },
  ".cm-activeLineGutter": { background: "none" },
  ".cm-column-line": { color: "#595959", fontSize: ".8rem" },
  ".cm-content": {
    "font-family": lightTheme.font,
    "font-weight": 400,
    "font-size": "16px",
    "background-color": lightTheme.backgroundColor
  },
  ".cm-control-panel-nav": { display: "flex", "align-items": "center" },
  ".cm-end-grid-line": { color: "#595959" },
  "&.cm-focused": { "outline-style": "none" },
  ".cm-gutters": { width: measures.editor.landscape.gutter, "background-color": lightTheme.backgroundColor, "border-right": "none", color: "#595959" /* CM default #6c6c6c is 5.25:1; this is 7:1 */ },


  ".cm-line": {
    // "padding-inline-start": "2rem",
    // "padding-inline-end": "2rem",
  },
  ".cm-row-line": { color: "#595959" },
  ".cm-navigation-panel": { display: "flex", "align-items": "center", "justify-content": "center" },
  ".cm-page-line": cmPageLine,
  ".cm-page-numbers-gutter-gutter": {
    "width": `${measures.editor.landscape.gutter}`,
  },
  ".cm-placeholder-line": { color: "#595959", "letter-spacing": ".3rem" },
  ".cm-scroller": { height: measures.editor.landscape.height, overflow: "auto" },
  ".cm-split-page-line": { color: colors.textSafe.magenta },
  ".cm-sticky-menu-line": { color: colors.textSafe.magenta },
  ".cm-panel-lint": {
    backgroundColor: colors.lightGrey,
    color: colors.tufte.black,
    borderTop: `1px solid ${colors.editorBorderGrey}`
  },
  // Tooltip container for lint diagnostics (popover)
  // Keep outer container neutral; allow inner UL to render the card/shadow
  ".cm-tooltip:has(.cm-tooltip-lint)": {
    overflow: "visible",
    padding: 0,
    boxShadow: "none",
    border: "none",
    backgroundColor: "transparent",
  },
  // Fallback: also style the inner lint list in case container styles are overridden
  ".cm-tooltip .cm-tooltip-lint.cm-tooltip-section": {
    backgroundColor: lightTheme.backgroundColor,
    borderRadius: "10px",
    border: `1px solid ${colors.editorBorderGrey}`,
    boxShadow: "0 2px 6px rgba(0,0,0,0.12), 0 12px 24px rgba(0,0,0,0.12)",
    position: "relative",
    listStyle: "none",
    margin: "6px",
    padding: "6px 0",
    display: "block",
    maxWidth: "min(520px, 92vw)",
  },
  ".cm-tooltip-hover": {
    backgroundColor: "transparent !important",
    border: "none !important"
  },
  ".cm-tooltip-lint .cm-diagnostic": {
    fontFamily: lightTheme.font,
    fontSize: ".8rem",
    maxWidth: "480px",
    padding: "10px 14px",
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
  },
  ".cm-tooltip-lint .cm-diagnostic + .cm-diagnostic": {
    borderTop: `1px solid ${colors.editorBorderGrey}`,
  },

  ".cm-tooltip-lint .cm-diagnostic-error": {
    backgroundColor: lightTheme.backgroundColor,
    color: colors.tufte.black,
  },
  ".cm-tooltip-lint .cm-diagnostic-warning": {
    backgroundColor: lightTheme.backgroundColor,
    color: colors.tufte.black,
  },
  ".cm-tooltip-lint .cm-diagnostic-info": {
    backgroundColor: lightTheme.backgroundColor,
    color: colors.tufte.black,
  },
  ".cm-tooltip-lint .cm-diagnosticText": { lineHeight: 1.3 },
  ".cm-tooltip-lint .cm-diagnosticSource": {
    opacity: 0.7,
    fontSize: "0.75rem",
    marginTop: "2px",
  },
  // Group and style action buttons (e.g., "Remove")
  ".cm-tooltip-lint .cm-diagnosticActions": {
    marginTop: "8px",
    display: "flex",
    justifyContent: "flex-end",
    gap: "6px",
  },
  ".cm-tooltip-lint .cm-diagnosticAction": {
    fontSize: ".75rem",
    lineHeight: 1.2,
    padding: "4px 8px",
    borderRadius: "6px",
    border: `1px solid ${colors.editorBorderGrey}`,
    backgroundColor: colors.lightGrey,
    color: colors.tufte.black,
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    whiteSpace: "nowrap",
    marginLeft: "6px",
  },
  ".cm-tooltip-lint .cm-diagnosticAction:first-of-type": {
    marginLeft: "auto",
  },
  // (No arrow overrides for lint; card styling is on the inner UL only)
  ".cm-panel-lint ul": {
    padding: "0 10px",
    listStyle: "none",
  },
  ".cm-panel-lint .cm-diagnostic": {
    padding: "5px 0",
    borderBottom: `1px solid ${colors.editorBorderGrey}`,
  },
  ".qp-lint-marker-container": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%",
  },
  ".cm-lint-marker": {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    cursor: "pointer",
  },
  ".cm-lint-marker-error": {
    backgroundColor: colors.textSafe.red,
  },
  ".cm-lint-marker-warning": {
    backgroundColor: colors.brand.yellow,
  },
  ".cm-text-modifier-animate": { color: colors.textSafe.blue, "font-size": "0.8rem" },
  ".cm-text-modifier-end-animate": { color: colors.textSafe.blue },
  ".cm-text-modifier-bold": { "font-weight": "bold" },
  ".cm-text-modifier-italic": { "font-style": "italic" },
  ".cm-text-modifier-underline": { "text-decoration": "underline", "text-decoration-thickness": "2px" },
  ".cm-control-panel": { display: "flex", "align-items": "center", "justify-content": "center" },
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: lightTheme.font,
      fontSize: ".8rem",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "13em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li > .image-preview": {
        "vertical-align": "middle",
        "background-position": "center",
      },

      "& > li > .color-block": {
        "vertical-align": "middle",
      },

      "& > li, & > completion-section": {
        padding: "3px 3px",
        lineHeight: 1,
      },
      textOverflow: "ellipsis",
      cursor: "pointer",
    },
    "& > li": {
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7,
      },
    },
  },
  // non stantard classes

  ".qp-row-marker-gutter": {
    "background": colors.brand.yellow,
    "width": "1px",
    "align-self": "end"
  },
  ".qp-end-grid-marker-gutter": {
    "background": colors.brand.yellow,
    "width": "1px",
    "align-self": "end"
  },
  ".qp-split-page-marker-gutter": {
    "background": colors.textSafe.magenta,
    "width": "1px",
    "align-self": "end"
  },
  ".qp-active-line-gutter": {
    /* current-line indicator: 1.4.11 needs >=3:1 vs the gutter; 2.4.13 (AAA)
       wants indicators >=2px. Was 1px of #7fd1f6 at 1.34:1 — near-invisible. */
    "background": "#5335C9",
    "width": "3px",
    "border-radius": "2px",
    "margin-right": "12px",
    "align-self": "end"
  },
  ".qp-gutter-pageNumber": {
    "display": "flex",
    "align-items": "center",
    "justify-content": "center",
    "height": "100%"
  },
  ".qp-keyword-color": { "font-size": "0.8rem", "font-style": "italic", "color": colors.textSafe.blue, "margin-inline-end": "0.24rem" },
  ".qp-keyword-no-text-color": { "font-size": "0.8rem", "font-style": "italic", "color": colors.textSafe.blue },
  ".qp-modifier": {
    // "padding-block-start": "0rem !important", 
    // "margin-block-start": "-0.75rem", 
    "font-size": "0.8rem",
    "font-style": "italic",
    "color": colors.textSafe.blue

  },
  ".qp-modifier-color": { "margin-inline-end": "0.24rem", "color": colors.textSafe.red },
  ".qp-read-text": { "font-style": "italic", "color:": colors.tufte.black },
  ".qp-stack-modifier-color": { "font-size": "0.8rem", "color": colors.textSafe.blue },

});


